import { TRootState } from 'redusers';

export const selectIsList = (state: TRootState) => state.global.view.isList;